<template>
  <v-app>
    <byu-header id="hide-from-print">
      <byu-user-info-oauth slot="user"></byu-user-info-oauth>
      <h1 slot="site-title">
        <router-link to="/">LSIF Applications</router-link>
      </h1>
      <byu-menu slot="nav">
        <router-link to="/apply">Apply</router-link>
        <router-link to="/available">Available Internships</router-link>
        <router-link to="/submissions" v-if="isAdmin || isFaculty">View Student Submissions</router-link>
        <router-link to="/admin" v-if="isAdmin">Admin</router-link>
      </byu-menu>
    </byu-header>
    <div class="page-content">
      <router-view v-if="isAuthenticated"/>
    </div>
    <byu-footer></byu-footer>
  </v-app>
</template>

<script>
import store from "./store/index";
import * as authn from "../node_modules/@byuweb/browser-oauth/byu-browser-oauth.mjs";
import { getUserByNetId } from "./services/services";

export default {
  name: "App",

  components: {},

  data: () => ({
    isAuthenticated: false,
    isAdmin: false,
    isFaculty: false,
    showErrorDialog: false,
  }),
  created() {
    var observer = new authn.AuthenticationObserver(
      ({ state, token, user, error }) => {
        if (user) {
          store.commit("setAuthToken", token.bearer);
          store.commit("setUser", user);
          this.isAuthenticated = true;
          getUserByNetId(user.netId).then((data) => {
            this.roleId = data.roleId;
            user.roleID = data.roleId;
            store.commit("setUser", user);
            if (data.status === 404) {
              if (!window.location.href.includes("Database")) {
                localStorage["error"] = JSON.stringify(
                  "User is not registered in the database"
                );
                window.location.href =
                  window.location.origin +
                  "/error?status=" +
                  data.status +
                  "&url=" +
                  "Users/" +
                  user.netId +
                  "&statusText=" +
                  "There is no user with this NetID in the Database. Contact your supervisor to be added to the database.";
              }
            }
            if (this.roleId == 1) {
              this.isAdmin = true;
            }
            else if (this.roleId == 2) {
              this.isFaculty = true;
            }
            let login = localStorage["login"];
            if (login == "true") {
              // Check if they just logged in if they have redirect them
              let path = localStorage.getItem("path");
              localStorage.setItem("login", "false");
              localStorage.removeItem("path");
              if (path) this.$router.push(path);
            }
          });
        }
        if (state == "unauthenticated") {
          // if they arent logged in and they are trying to access a prtected page force them to log in
          store.commit("setUser", null);
          var name = this.$router.currentRoute.path || "";
          localStorage.setItem("path", name);
          localStorage.setItem("login", "true");
          authn.login();
        }
        if (state == "expired") {
          this.logout();
        }
      }
    );
  },
  computed: {
    errorMessage() {
      return store.state.Error;
    },
  },
  watch: {
    errorMessage(newValue) {
      if (newValue != null && newValue != undefined)
        this.showErrorDialog = true;
      else this.showErrorDialog = false;
    },
  },
};
</script>

<style lang="scss">
.page-content {
  margin: 0 auto;
  max-width: 1200px;
  width: 100%;
  height: 100%;
  flex: 1;
  box-sizing: border-box;
  margin-top: 16px;
  background-color: white;
  flex-direction: column;
  overflow: visible;
}

html,
body {
  min-height: 100%;
  background-color: #f6f6f6;
  font-family: "HCo Ringside Narrow SSm";
  color: black;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Public Sans";
}

#app {
  display: flex;
  flex-direction: column;
  height: 100%;
}

body * {
  box-sizing: border-box;
}

byu-footer {
  margin-top: 25px;
}

.material-icons {
  font-family: "Material Icons";
  font-weight: normal;
  font-style: normal;
  font-size: 24px; /* Preferred icon size */
  display: inline-block;
  line-height: 1;
  text-transform: none;
  letter-spacing: normal;
  word-wrap: normal;
  white-space: nowrap;
  direction: ltr;

  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  -moz-osx-font-smoothing: grayscale;
  font-feature-settings: "liga";
}

#loading-page {
  width: 100%;
  height: 40vh;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}
.ql-align-center {
  display: flex !important;
  justify-content: center !important;
}
</style>
